export default {
 privateKey: 'davich30*',


}